module.exports = __webpack_public_path__ + "static/media/dontColor.04bf9eb1.svg";